/* eslint-disable quotes */
const en = {
  typeYourMessageHere: 'Type your message here...',
  Home: 'Home',
  homeVisit: 'Home visit',
  centerVisit: 'Center visit',
  Select: 'Select',
  yourName: 'Your Name',
  firstName: 'First Name',
  removeItemFromList: 'Remove Item from the list',
  orderPlaceSuccesfully: 'Order successfully placed',
  YourWalletMoneyRecharged: 'You wallet money recharged with',
  signinUP: 'Signing up...',
  enterRefralCode: 'Enter Referal Code',
  haveARefralCode: 'Have a referal code',
  accountCreated: 'Account Created!',
  clickAndCollect: 'Click & Collect',
  courier: 'Courier',
  charges: 'Charges',
  alphabets: 'alphabets',
  alphabet: 'alphabet',
  orderDate: 'Order Date',
  yourPasswordContainAtLeast: 'Your password must contain at least',
  expectedDate: 'Expected Date',
  page: 'Page',
  loadMore: 'Load More',
  allProducts: 'All Products',
  inviteAFriendUsingRefralCode: 'Invite your friends using your Referal Code',
  refralCode: 'Refer Code :',
  successfullyAdded: 'Successfully Added !',
  pleaseAddPinCode: 'Please Add Pincode',
  sorryWeDonapostServerArea: 'Sorry we don&apost server this area',
  noBlogFound: 'No blog Found',
  found: 'found',
  deliveredTo: 'Delivered to',
  yes: 'Yes',
  no: 'No',
  delete: 'Delete',
  save: 'Save',
  cancel: 'Cancel',
  login: 'login',
  ok: 'ok',
  signup: 'SIGNUP',
  logout: 'Logout',
  hello: 'HELLO',
  myOrders: 'My Orders',
  itemHasBeenCancel:
    'If an item has been cancelled,please see your invoice for accurate billing.',
  orderUpdate: 'Order Update',
  myAddresses: 'My Addresses',
  changePassword: 'Change Password',
  updatePassword: 'Update Password',
  updating: 'updating...',
  results: 'results',
  result: 'result',
  signOut: 'Sign Out',
  checkout: 'Checkout',
  wishlist: 'Wishlist',
  myWishlist: 'My Wishlist',
  myWallet: 'My Wallet',
  address: 'Address',
  address1: 'Address 1',
  address2: 'Address 2',
  address3: 'Address 3',
  address4: 'Address 4',
  landmark: 'Landmark',
  loading: 'loading...',
  SigningIn: 'Signing in',
  location: 'Location',
  city: 'City',
  pincode: 'Pincode',
  deliveryIcon: 'delivery',
  deliveringTo: 'Delivering to',
  referAFriend: 'Refer A Friend',
  confirmDeleteAddress: 'Confirm that you wish to delete this address',
  dontServiceSelectedLocation: `Sorry we don't service the selected location currently!`,
  weDontDeliverToThisLocationYet: 'We dont deliver to this location yet',
  areYouSureYouWantToDeleteThisAddress:
    'Are you sure you want to delete this address?',
  yesDelete: 'Yes, Delete',
  yesConfirm: 'Yes, Confirm',
  selectAddress: 'Select Address',
  weDontDeliverToThisLocationCurrently:
    'We dont deliver to this location currently!',
  addToCart: 'ADD TO CART',
  addToBag: 'ADD TO BAG',
  goToBag: 'GO TO BAG',
  myCart: 'My Cart',
  bag: 'BAG',
  cart: 'CART',
  priceDetails: 'Price Details',
  cancelled: 'Cancelled',
  orderPlaced: 'Order Placed',
  orderPending: 'Order Pending',
  orderDetails: 'Order Details',
  placedOn: 'Placed On',
  delivered: 'Delivered',
  retreiving: 'retreiving',
  submit: 'Submit',
  oldPassword: 'Old Password',
  newPassword: 'New Password',
  yourNewPasswordMust: 'Your new password must:',
  saveChanges: 'Save Changes',
  reenterNewPassword: 'Re-enter new Password',
  totalPayable: ' Total Payable',
  totalToPay: 'Total to pay',
  grandTotal: 'Grand total',
  enterCouponCode: 'Enter coupon code',
  enterGiftCode: 'Discount Code or gift card',
  enterCoupon: 'Enter Coupon',
  poNumber: 'P.O Number',
  statement: 'Statements',
  statementofAccounts: 'Statement of Accounts',
  statementsAsOfNow: 'Statement As Of:',
  paymentInclusiveOfAllTaxes: 'Payment inclusive of all taxes',
  inclusiveOfAllTaxes: 'Inclusive of all taxes',
  placeOrder: 'PLACE ORDER',
  paymentModeNotConfigured: 'Payment mode not configured',
  paymentMode: 'Payment Mode',
  online: 'Online',
  completeOrder: 'Complete Order',
  cashOnDelivery: 'Cash On Delivery',
  buildingName: 'Building name',
  deliveryTo: 'Delivery to',
  collectFrom: 'Collect from',
  deliveryAddress: 'Delivery Address',
  shippingAddress: 'Shipping address',
  submissionReceived: 'Your submission has been received',
  clickBelowToSubmitAgain: 'Click below to submit again',
  submitAgain: 'Submit Again',
  shipTo: 'Ship to',
  pickupAddress: 'Pick up Address',
  thereIsNoAddressToDeliverPleaseAddAnAddress:
    'There is no address to deliver, Please add an address',
  payOnline: 'Pay Online',
  payOnDelivery: 'Pay on Delivery',
  next: 'Next',
  loadingUserDetails: '...loading user details',
  description: 'Description',
  highlights: 'Highlights',
  dateTime: 'Date and Time',
  selectDateAndTime: 'Select Date & Time',
  selectDate: 'Select Date',
  enterPersonalDetails: 'Enter Personal Details',
  account: 'Account',
  contact: 'Contact',
  personalDetails: 'Personal Details',
  receiverDetails: 'Receiver Details',
  addNewAddress: 'ADD NEW ADDRESS',
  addNewAddressDefault: '+ ADD NEW ADDRESS',
  addNew: 'Add New',
  yourCarIsEmpty: 'Your cart is empty',
  yourBagIsEmpty: 'Your bag is empty',
  continueShopping: 'CONTINUE SHOPPING',
  emptyCartDefault: "Looks like you haven't made your choice yet",
  noItemsInWishlist: 'No items in wishlist',
  noImageAvailable: 'No Image Available',
  apply: 'Apply',
  applyFilter: 'Apply Filters',
  brands: 'Brands',
  offer: 'Offer',
  offers: 'Offers',
  price: 'Price',
  size: 'Size',
  sellers: 'Sellers',
  quicklinks: 'Quick links',
  shippingPolicy: 'Shipping policy',
  cancellationAndRefundPolicy: 'Cancellation and refund policy',
  blog: 'Blog',
  value: 'Value',
  customPage: 'Custom page',
  logIn: 'Log In',
  loggingIn: 'Logging In...',
  emailID: 'Email ID',
  passwordSentSuccessfully:
    'Your password is sent to your registered mobile number',
  newPasswordSentSuccessfully:
    'Your new password is sent to your registered mobile number',
  newPasswordSentSuccessfullyToMail:
    'Your new password is sent to your registered email',
  pleaseEnterRegisteredEmailMobileNumber:
    'Please enter your registered email, mobile number to receive a system generated password',
  setYourOwnPassword: 'Set your own password',
  alreadyHaveAnAccount: 'Already have an account?',
  alreadyHaveAnAccountSingle: 'Already have an account ?',
  PasswordChanged: 'Successfully changed your password',
  menu: 'Menu',
  editAddress: 'EDIT ADDRESS',
  thereAreNoOrdersFound: 'There are no orders found',
  cancelling: 'Cancelling...',
  status: 'Status:',
  amount: 'Amount:',
  amountForOrderListingPage: 'Amount',
  pendingAmount: 'Pending Amount:',
  phone: 'Phone',
  email: 'Email',
  name: 'Name',
  enterName: 'Enter Name',
  fastSelling: 'Fast Selling',
  registeredSuccessfully: 'You have registered successfully',
  emailOrPhoneNumber: 'Email or Mobile Number in international format',
  phoneNumberInternationFormate: 'Mobile number in international format',
  phoneNumberCheckout: 'Phone Number',
  forgotPassword: 'Forgot Password?',
  signUp: 'Sign up',
  signUpHere: 'Sign Up Here',
  register: 'Register',
  dontHaveAnAccount: 'Don’t have an account ?',
  donthaveAnAccount: 'Don’t have an account? ',
  here: 'here',
  profile: 'Profile',
  notAMemberYet: 'Not a member yet?',
  notNow: 'Not Now',
  showMoreProducts: 'SHOW MORE PRODUCTS',
  myFamilyMember: 'My family member',
  myTeamMember: 'My Team Members',
  myFamily: 'My Family',
  noProductsFound: 'No products found',
  products: 'Products',
  product: 'Product',
  productNotFound: 'Product Not Found',
  totalItems: 'Total Items',
  totalAmount: 'Total Amount',
  discount: 'Discount',
  slotCharge: 'Slot Charge',
  slotDiscount: 'Slot Discount',
  couponDiscount: 'Coupon Discount',
  deliveryDiscount: 'Delivery Discount',
  subTotal: 'Sub Total',
  applyHere: 'APPLY HERE',
  apply: 'Apply',
  continueToCheckout: 'CONTINUE TO CHECKOUT',
  checkOut: 'CHECK OUT -',
  proceedToCheckout: 'Proceed to Checkout',
  yourPasswordMustContainAtLeast: 'Your password must contain at least',
  beAtLeastEightCharactersInLength: 'Be at least 8 characters in length',
  notBeSameAsYourCurrentPassword: 'Not be same as your current password',
  searchShirtsTrousers: 'Search Shirts, Trousers...',
  password: 'Password',
  buyNow: 'BUY NOW',
  buyItNow: 'BUY IT NOW',
  enterOldPassword: 'Enter old password',
  enterNewPassword: 'Enter new password',
  reEnterNewPassword: 're-enter new password',
  haveAPromoCode: 'Have a promo code?',
  haveADiscountCoupon: 'Have a discount coupon?',
  min: 'Min',
  max: 'Max',
  searchForProductsBrandsAndMore: 'Search for products, brands and more',
  searchIcecream: 'Search ice Cream',
  searchForStyleCollections: 'Search for Style, Collection...',
  searchForMedicalEquipmentsOrDevices:
    'Search for medical equipment or devices',
  searchForProducts: 'Search for products',
  expectedDeliveryDescription: `Due to holidays or fortuitous events, delivery times may take longer than expected.`,
  deliveryCharge: 'Delivery Charge',
  enterYourNumber: 'Enter your number',
  payNow: 'Pay Now',
  Delivery: 'Delivery ',
  Filter: 'Filter',
  sortBy: 'Sort By',
  downloadApp: 'Download App',
  aboutUs: 'About us',
  contactUs: 'Contact Us',
  helpCenter: 'Help Center',
  news: 'News',
  signIn: 'Sign In',
  signin: 'Sign in',
  createAccount: 'Create account',
  Search: 'Search',
  quickLinks: 'Quick Links',
  ourPolicies: 'Our Policies',
  visitUs: 'Visit Us',
  socialMedia: 'Social Media',
  termsCondition: 'Terms & Conditions ',
  privacyPolicy: ' Privacy Policy',
  viewAll: 'View All',
  seeAll: 'see all',
  viewLess: 'View Less',
  savedAddress: 'Saved Addresses',
  cancelStatus: 'As per your request, order has been cancelled',
  confirmNewPassword: 'Confirm new password',
  addtoCart: 'Add to cart',
  chooseOrderType: 'Choose order type',
  orderType: 'Order Type',
  OR: 'Or',
  of: 'of',
  getInTouch: 'Get in touch',
  weAccpetOrdersWithAMinimumValueOf:
    'We accept orders with a minimum value of ',
  pleaseAddProductsWorth: ' Please add products worth ',
  minimumOrderAmountWarning: 'Your order value is below the minimum limit!',
  moreToPlaceYourOrder: ' more to place your order.',
  invalidUserName: 'You entered an incorrect Name',
  invalidEmailPhoneNumber: 'You entered an incorrect Email or Phone Number',
  requiredPersonalDetails: 'Required Personal Details to place the Order',
  invalidPassword: 'You entered an incorrect password',
  invalidPhone: 'Please enter valid phone number',
  invalidEmail: 'Please enter valid email id',
  seeOtherVariants: 'See other variants',
  searchForMedicineAndWellnessProducts: 'Search for products, brands and more',
  searchresults: 'Search results for ',
  noPrescription: "Don't have a prescription?",
  consultTeleDoctor: 'Consult Tele Doctor',
  canStillPlaceOrder: 'You can still place an order',
  addProductsToCart: 'Add products to your cart',
  optFor: 'Opt for',
  free: 'free',
  similarProducts: 'Similar Products',
  specialOfferApplied: 'Special offer applied',
  teleConsultationFromDoctor: 'tele-consultation from our doctor at Checkout',
  placeYourOrder: 'Place your order',
  itemsFromPastOrder: 'Items from Past Order',
  prescriptionCheck: 'Prescription Check',
  prescriptionDescription: `Some Items in your order may need doctor’s prescription to be added. Please upload supporting prescription/s OR opt for a FREE tele-consultation from our doctor. `,
  uploadPrescription: 'Upload Prescription',
  freePrescription: 'Get FREE tele-consultation from our doctor',
  DeliverWithIn240Min: 'Delivery within 240 min of ordering',
  within240Min: 'Within 240 minutes',
  prescriptionDoctor: 'Get free prescription from our doctor',
  DoctorDescription: 'Our Doctor will call you shortly.',
  addPrescription: 'Add prescription',
  UploadPrescription: 'Upload Prescription',
  SizeIsToLarge: 'File size is too large, File size should be less then 15 MB',
  deliveryWithin180Min: 'Delivery within 180 min of ordering',
  within180Min: 'Within 180 minutes',
  validPrescriptionNeeded: 'Valid prescription needed',
  validPrescriptionDeliveryWithin180:
    'Valid prescription must be uploaded to get delivery within 180 min.',
  validPrescriptionShouldHave: 'Valid prescription should clearly have',
  doctorsDetails: `Doctor's details`,
  patientDetails: 'Patients details',
  dateOfPrescription: 'Date of prescription',
  medicineWithDosage: 'Medicine details with dosage',
  ourDoctorWillCall:
    'Our doctor will call you shortly. Please be available to receive a call from our doctor.',
  noConnectDoctor:
    'If our doctor is not able to connect with you then we will put the order on hold leading to delay and possible cancellation.',
  deliverTo: 'Deliver to',
  phoneNumber: 'Mobile Number',
  registering: 'Registering...',
  signingUp: 'Signing Up...',
  signingIn: 'Signing In...',
  verifyNumber: 'Verify Number',
  setPassword: 'Set Password',
  enterVerificationCode: 'Enter verification code',
  inviteMember: 'Invite Member',
  brochureDownload: 'Click here to download the PDF brochure',
  brochure: 'Brochure',
  invite: 'Invite',
  verifying: 'Verifying...',
  verify: 'Verify',
  enterSystemGeneratedPassword:
    'Please enter the system generated password sent to',
  confirmPassword: 'Confirm Password',
  savePassword: 'Save Password',
  saving: 'Saving...',
  adding: 'Adding...',
  offerProducts: 'Offer products',
  OrderSummary: 'Order Summary',
  summary: 'Summary',
  continue: 'Continue',
  payment: 'Payment',
  promoCode: 'promo Code',
  EnterDeliveryArea: 'Enter Delivery Area',
  COD: 'COD',
  SelectDateAndTime: 'Select Date And Time',
  YourOrderHasBeenSuccessfullyPlaced: 'Your order has been successfully placed',
  GoHome: 'Go home',
  YourPaymentIsReceived: 'Your payment is received',
  YourRechargeIsSuccessful: 'Your Wallet Recharge is Successful',
  cartAmount: 'Cart Amount',
  retry: 'Retry',
  OrderFailed: 'Order Failed',
  errorMessage:
    'Oops! An error occured while placing the order. You can try again',
  SelectText: 'Select your Picking Address',
  weAreDeliveringTo: 'We Are Delivering To',
  AddNewAddressText: 'Add New Address',
  editAddressText: 'Edit address',
  addAddress: 'Add address',
  goBack: 'Go Back',
  SlotError: 'No Slot is Available on This Date',
  SelectDeliveryAddress: 'Select Delivery Address',
  deliveryNear: 'Delivering near',
  SelectDeliveryArea: 'Select Delivery Area',
  SearchLocation: 'Search Location',
  store: 'store',
  enterEmailOrPhone: 'Enter your email or phone number',
  enterPhone: 'Enter phone number',
  logo: 'Logo',
  findProductFromOurList: 'Search for products',
  delivery: 'Delivery',
  mobile: 'Mob: ',
  writeToUs: 'Write to us',
  allRights: '. All Rights ',
  received: 'received',
  exampleEmail: 'example@abc.com',
  haveLogin: 'Have Login ?',
  successfullyChangedYourPassword: 'Successfully changed your password',
  retrieving: 'Retrieving',
  retrieve: 'Retrieve',
  enterAddress: 'Enter address',
  enterAddressLine1: 'Enter address line 1',
  enterAddressLine2: 'Enter address line 2',
  enterArea: 'Enter Area',
  enterPincode: 'Enter Pincode',
  enterCity: 'Enter City',
  weDontServe: 'Sorry we do not serve this location',
  beAtLeast8CharacterInLength: 'Be at least 8 character in length',
  NotBeSameAsYourCurrentPassword: 'Not be same as your current password',
  NotContainsCommonPasswords: 'Not contains common passwords',
  resetPassword: 'Reset Password',
  resetting: 'Resetting...',
  lowerCase: 'lower case',
  upperCase: 'upper case',
  sureEmptyCart:
    'Are you sure you would like to remove these item from the shopping cart?',
  character: 'character',
  characters: 'characters',
  symbol: 'symbol',
  symbols: 'symbols',
  numeric: 'numeric',
  see: 'See',
  otherVariants: ' other variants',
  off: '% off',
  Pcs: 'Pcs',
  productCount: 'Product Count',
  cancelConfirmation: 'Cancel the order?',
  orderNumber: 'Order Number',
  preferredSlot: 'Preferred Slot',
  invoiceAmount: 'Invoice Amount',
  invoice: 'Invoice',
  invoiceUnavailable: 'Invoice is not available for order',
  pastOrderStatus: 'Status',
  pastOrders: 'Past Orders',
  allOrders: 'All Orders',
  pastItem: 'Past Items',
  fullname: 'Full Name',
  noServiceMsg: "Sorry we don't serve this area",
  phoneErrorMessage: 'Please Enter valid phone number',
  dialCodeErrorMessage: 'Please Enter valid dial code',
  incorrectInfoForSignUp:
    'Please check account information again or the account already exists',
  confirmDelete: 'Confirm delete address ?',
  enterNewAddress: 'Enter New Address',
  productDescription: 'Product Description',
  imageIndicativeText: '* Image shown is indicative of actual product',
  imageCautionText:
    '* Product packaging of actual product delivered may differ based on region and recent stock.',
  productImage: 'product image',
  enterName: 'Enter full name',
  enterEmail: 'Enter email',
  enterLandmark: 'Search your nearest landmark',
  signInHere: 'Sign in here',
  account: 'Account',
  myAccount: 'My Account',
  filters: 'Filters',
  date: 'Date',
  orderStatus: 'Order Status',
  item: 'Item',
  items: 'Items',
  sorry: 'Sorry',
  noPastItems: 'No past items to show',
  pay: 'Pay',
  deliveredOn: 'Delivered on',
  cancelledOn: 'Cancelled on',
  returnedOn: 'Returned on',
  returns: 'Returns',
  didYouForget: 'Did you forget?',
  youMayAlsoLike: 'You may also like!',
  orderID: 'Order ID:',
  orderReference: 'Order',
  referenceNumber: 'Reference Number',
  preferredDate: 'Preferred Date & Slot:',
  cancelOrder: 'Cancel Order',
  itemsInOrder: 'Items in Order',
  medicalDescription: 'Medical Description',
  yourOrderIsPlaced: 'Thank you! Your order is placed.',
  placeAnotherOrder: 'Place Another Order',
  yourPaymentIsReceived: 'Your payment is received',
  yourPaymentIsPending: 'Your payment is pending',
  orderDeliverShortly: 'Your order will be delivered shortly.',
  placed: 'Placed',
  packed: 'Packed',
  totalSavings: 'Total Savings',
  mrp: 'MRP ',
  srp: 'SRP',
  quantity: 'Quantity',
  youPay: 'You Pay',
  remove: 'Remove',
  totalCartValue: 'Total cart value',
  lastOneMonth: 'Last 1 Month',
  lastThreeMonth: 'Last 3 Month',
  lastSixMonth: 'Last 6 Month',
  lastOneYear: 'Last 1 Year',
  pendingOrder: 'pending',
  dispatched: 'Dispatched',
  completed: 'completed',
  cancelledOrder: 'cancelled',
  retryPayment: 'Retry Online Payment',
  knowHow: 'Know How',
  itemsRequirePrecription: 'Items that require prescription',
  otherItems: 'Other items',
  receiverNameOptional: 'Name (optional)',
  changeAddress: 'Change address',
  newAddress: 'Add new address',
  doctorDescriptionMob: 'Our Doctor will call you shortly.',
  paymentDetails: 'Payment details',
  onlinePayment: 'Online payment',
  prescriptionDetails: 'Prescription details',
  transactionId: 'Transaction ID: ',
  transactionHistory: 'Transaction History',
  walletCashback: 'Wallet Cashback',
  prescription: 'Prescription',
  nameOfPatient: 'Name of patient',
  nameOfDoctor: 'Name of doctor',
  uploading: 'Uploading...',
  fileUploadError: 'Error while uploading the file. Please try again',
  only: 'Only',
  outOf: 'out of',
  itemsCartDeliverable:
    'items in your cart are available for delivery to this address.',
  weDontDeliveryLocationYet: ' We dont deliver to this location yet',
  areYouSureChangeAddress: 'Are you sure you want to change address?',
  change: 'Change',
  caution: 'Caution!',
  slotNotAvailable: 'No Slot is Available on This Date',
  check: 'Check',
  variants: 'Variants',
  noAddressFound: 'No saved address found',
  saveAddress: 'Save Address',
  noSlotsFound: 'No slots found',
  send: 'Send',
  orderItemsNeedPrescription: 'Your order has items that need prescription!',
  uploadValidPrescription: 'upload a valid prescription',
  please: 'Please',
  orOptFor: 'or opt for',
  teleConsulting: 'tele-consulting.',
  or: 'or',
  cannotAddMoreThanTen: 'You cannot add more than 10 quantity',
  outOfStock: 'Out Of Stock',
  soldOut: 'SOLD OUT',
  orderedQty: 'Ordered Qty',
  finalQty: 'Final Qty',
  dontCancel: `Don't cancel`,
  all: 'All',
  requiredField: 'This field is required',
  pinCodeValidation: 'Pincode must be 6 digits',
  signInOtp: 'Sign in with OTP',
  resendOtp: 'Resend OTP',
  requestOtp: 'Request for OTP',
  oneTimePassword: 'One Time Password',
  otpResent: 'OTP resent successfully. Please verify below.',
  enterOtp: 'Enter OTP',
  otpSendSuccess:
    'An OTP has been sent to your mobile number. Please verify below.',
  otpSendSuccessGetz:
    'An OTP has been sent to your Mobile number and/or Email. Please verify below.',
  addProducts: 'Add Products',
  noAccountExistsMobile:
    'No account exists with this mobile number. Please Sign up!',
  noAcountExistsUsername:
    'No account exists with this username. Please Sign up!',
  noAccountExistsEmail: 'No account exists with this email. Please Sign up!',
  incorrectPasswordRetry: 'Password is incorrect. Please retry!',
  freeDeliveryTag: 'Free delivery for orders above',
  medInMinutesLogin: 'Login to',
  medInMinutesSignUp: 'Sign up with',
  emailOrMobileNumber: 'Email or Mobile Number',
  requesting: 'Requesting...',
  resending: 'Resending...',
  useMyLocation: 'Use my current Location',
  fetchingMyLocation: 'Fetching your current Location',
  emailSuccessfullyVerified:
    'Your e-mail address has been successfully verified',
  somethingWentWrong: 'Something went wrong',
  enterYourLocation: 'Enter your location',
  addFullAddress: 'Add full address',
  shippingCharge: 'Shipping Charge',
  shipping: 'Shipping',
  couldNotFindMatch: "we couldn't found a match for ",
  pleaseTryAnotherSearch: '. Please try another search',
  expectedDelivery: 'Expected Delivery on',
  expectedDeliveryDate: 'Expected Delivery Date:',
  noSlotAvailable: 'No Slot Available',
  refundAmount: 'Refund Amount',
  amountPaid: 'Amount paid',
  downloadOurApp: 'Download our app',
  followUs: 'Follow Us',
  twitter: 'Twitter',
  facebook: 'Facebook',
  policyInfo: 'Policy Info',
  topCategories: 'Top Categories',
  allRightsReserved: 'All Rights Reserved',
  acceptedPaymentMethods: 'Accepted payment methods',
  knowUs: 'Know us',
  selectLocation: 'Select Location',
  searchAreaStreet: 'Search for area, streets...',
  onlinePaymentFailed: 'Your online payment has failed',
  total: 'Total',
  priceDiscount: 'Price Discount',
  productDetails: 'Product Details',
  isPendingPayment: 'is pending payment, please keep cash ready',
  couponAppliedSuccessfully: 'Coupon applied successfully',
  paymentNotSuccessfull: 'Payment was not successfull',
  tryAgain: 'Try again',
  canClickNextBtnPrescriptionNotRequired: `If your order doesn't have any prescription medicines, you can directly click Next to place your order.`,
  itemAddedToCart: 'Item Added to cart',
  wallet: 'Wallet',
  walletMoney: 'Wallet Money',
  credit: 'Credit',
  debit: 'Debit',
  balance: 'Balance',
  amountValue: 'Amount',
  expiry: 'Expiry',
  currentlyNoDataForThisSection: 'Currently there are no data for this section',
  addAmount: 'Add Amount',
  recharge: 'Recharge',
  addMoney: 'Add Money',
  recommended: 'Recommended',
  failed: 'Failed',
  congratulations: 'Congratulations',
  recharging: 'Recharging...',
  use: 'Use',
  via: 'Via',
  fromWalletBalance: 'from my wallet balance',
  moneyRecharedWith: 'Congratulations your Wallet Money is charged with ',
  failedWalletRecharge: `We are sorry the transaction failed. Any debited amount will get
  refunded within 5 business days.`,
  orderTotal: 'Order Total',
  totalAmountToPay: 'Total amount to pay',
  specialOffer: 'Special Offer',
  offerApplied: 'Offer Applied',
  qty: 'Qty',
  specialInstructions: 'Special instructions (if any)',
  purchaseOrderDetails: 'Purchase order details',
  addToWishlist: 'Add to Wishlist',
  endsIn: 'Ends in',
  days: 'days',
  hours: 'hours',
  minutes: 'minutes',
  newStockArriving: 'New Stocks arriving soon',
  itemMightSeprately: 'This item might ship separately',
  help: 'help',
  Shopnow: 'Shop now',
  inStock: 'In stock',
  copyRight: 'Copyright',
  allRightsReservedGetz: 'All Rights Reserved Getz Healthcare. A Member of',
  getzGroupOfCompanies: 'The Getz Group of companies',
  dataPrivacyPolicy: 'Data Privacy Policy',
  customerService: 'Customer Service',
  company: 'Company',
  loginToContinue: 'Login to continue',
  signinToContinue: 'Sign in to continue',
  welcomeBack: 'Welcome Back!',
  resetYourPassword: 'Reset your password',
  createAnAccountContinue: 'Create an account to continue',
  pleaseEnterEmailOrNumber: 'Please enter your email or phone number',
  cart: 'Cart',
  itemS: 'Item(s)',
  promo: 'Promo',
  promoText: 'Promo:',
  orderAgain: 'Order again',
  reOrder: 'Re-Order',
  emptyCart: 'Empty cart',
  savedItems: 'Saved items',
  saveItem: 'Save item',
  youDontHaveSavedItems: "You don't have any saved items",
  productInfo: 'Product info',
  relatedProducts: 'Related Products',
  shopByBrand: 'Shop by brand',
  categories: 'Categories',
  myDetails: 'My Details',
  myTeam: 'My Team',
  companyDetails: 'company details',
  personalInformation: 'personal information',
  securityDetails: 'security details',
  add: 'add',
  Add: 'Add',
  promotions: 'Promotions',
  promoPeriod: 'Promo Period',
  promoValidUntilSuppliesLast: '*promo valid until supplies last',
  emailAddress: 'Email address',
  companyName: 'Company name',
  contactNumber: 'Contact number',
  edit: 'Edit',
  copied: 'Copied',
  savedItem: 'Saved item',
  clearAll: 'Clear all',
  sortByNewFirst: 'new first',
  sortByNewLAst: 'new last',
  sortByPopularity: 'Popularity',
  sortByRelevance: 'relevance',
  sortByAZ: 'Name',
  sortByAToZ: 'A-Z Alphabets',
  sortByZToA: 'Z-A Alphabets',
  sortByLowToHighPrice: 'price asc',
  sortByHighToLowPrice: 'price desc',
  sortByLatest: 'new first',
  sortByDiscount: 'offer desc',
  sortByNewest: 'newest',
  sortByOldest: 'oldest',
  clear: 'clear',
  viewResults: 'view results',
  findABrand: 'Find a brand',
  position: 'Position',
  helpCanter: 'Help Center',
  ordersAndPayment: 'Orders and Payment',
  signUpForm: 'sign-up form',
  frequentlyAskedQues: 'Frequently Asked Questions',
  canIChangeMyDeliveryAddressAfterPlacingAnOrderQues:
    ' Can I change my delivery address after placing an order?',
  canIChangeMyDeliveryAddressAfterPlacingAnOrderAns:
    'We are unable to change your delivery address after placing an order. ',
  howMuchIsTheShippingCostQues: 'How much is the shipping cost?',
  howMuchIsTheShippingCostAns:
    'We currently offer free shipping on all orders.',
  howLongWouldItTakeForMyOrderToArriveQues:
    'How long would it take for my order to arrive?',
  howLongWouldItTakeForMyOrderToArriveAns:
    'Delivery times vary depending on your location. Kindly refer to the “Expected Delivery Date” upon checkout.',
  deliveryTimes:
    '*Delivery times maybe affected due to holidays, fortuitous events, etc.',
  whereAreYourProductsShippedFromQues: 'Where are your products shipped from?',
  whereAreYourProductsShippedFromAns:
    'Our products are shipped from our distribution centres in Taguig, Cebu, Iloilo, and Davao. The shipping point of your order will depend on your location.',
  myOrderIsDelayedWhatShouldIDoQues: 'My order is delayed, what should I do?',
  myOrderIsDelayedWhatShouldIDoAns:
    'There are many factors on why your order could be delayed. For more info, feel free to.',
  iHaveReceivedADamagedItemCanIReturnQues:
    'I have received a damaged item, can I return/replace it?',
  iHaveReceivedADamagedItemCanIReturnAns1: 'Kindly',
  iHaveReceivedADamagedItemCanIReturnAns2:
    'or your account manager if an item you received from us is damaged or defective.',
  CPM: '(CPM: there are still ongoing discussions about the SOA and invoices. It may not be available for viewing of all enrolled accounts)',
  howCanITrackMyOrderQues: 'How can I track my order?',
  howCanITrackMyOrderAns:
    'We will send you the tracking code of the delivery when the order has been sent.',
  canICancelMyOrderQues: 'Can I cancel my order?',
  canICancelMyOrderAns:
    'Confirmed orders cannot be cancelled without approval from Getz Healthcare.',
  iOrderedAProductBeforeQues:
    'I ordered a product before, but it is not online. How can I order it again?',
  iOrderedAProductBeforeAns1: 'Kindly',
  iOrderedAProductBeforeAns2:
    ' if you are interested to repurchase a product which is not in our online store.',
  canViewMyCreditLimitAndAvailableBalanceOnlineQues:
    'Can I view my credit limit and available balance online?',
  canViewMyCreditLimitAndAvailableBalanceOnlineAns: 'Yes.',
  howDoIKnowIfMyOrderIsConfirmedQues: 'How do I know if my order is confirmed?',
  howDoIKnowIfMyOrderIsConfirmedAns: `Once an order is submitted, you'll receive an email acknowledgement. The corresponding sales invoice will be available to you during the delivery.`,
  WhtaSreYourAvailablePaymentMethodsQues:
    'What are your available payment methods?',
  WhtaSreYourAvailablePaymentMethodsAns:
    'Your order needs to be paid within your approved credit term. Depending on your arrangement with your Account Manager, you can pay via check pick-up, bank-to-bank or direct deposit to Getz Healthcare’s partner banks.',
  areYouAbleToProvideASpecificTypeOfInvoiceQues:
    'Are you able to provide a specific type of invoice e.g. VATEX, Zero Rated and With VAT etc.?',
  areYouAbleToProvideASpecificTypeOfInvoiceAns1: 'Yes. Kindly',
  areYouAbleToProvideASpecificTypeOfInvoiceAns2:
    'or your account manager for more information.',
  canIAddRemoveItemsAfterMakingAnOnlinePurchaseQues:
    'Can I add/remove items after making an online purchase?',
  canIAddRemoveItemsAfterMakingAnOnlinePurchaseAns:
    'We are unable to add or remove items once the order has been submitted.',
  isThereAminimumPurchaseAmountQues: 'Is there a minimum purchase amount?',
  isThereAminimumPurchaseAmountAns:
    'Yes. we require all orders to have a minimum amount of Php5,000',
  howdoIopenanaccountwithGetzHealthcareQues:
    'How do I open an account with Getz Healthcare?',
  howdoIopenanaccountwithGetzHealthcareAns:
    'Kindly contact us if you are interested to be an accredited customer of Getz Healthcare. If you already have an account with us and wish to open an online account to access to e-store, you may use our online',
  isThereAnOrderCutOffTimeQues: 'Is there an order cut-off time?',
  isThereAnOrderCutOffTimeAns:
    'The daily sales order cut-off is at 12:00pm. Orders received after 12:00pm will be processed for the following working day.',
  whatSoldToNumberAndWhereCanIFindQues:
    'What is a "Sold to" number and where can i find it?',
  whatSoldToNumberAndWhereCanIFindAns1:
    'All existing Getz Healthcare Phillippines Customers have a unique Customer Account Number also known as their "sold to" number. This can be found on the upper left side of their Getz Healthcare order invoice.',
  kindly: 'Kindly',
  whatSoldToNumberAndWhereCanIFindAns2:
    'or your account manager for more information.',
  alreadySignUpWhenCanILoginQues:
    'I have already signed up for an account, when can I login?',
  alreadySignUpWhenCanILoginAns:
    'Your login credentials will be emailed to you soon after our agents have verified the information you have provided during the sign up process.',
  howCanIEditUserAndBusinessInformationQues:
    'How can I edit my user and business account information?',
  howCanIEditUserAndBusinessInformationAns1:
    'If you wish to edit your user and business account information, kindly',
  howCanIEditUserAndBusinessInformationAns2:
    'as we will need to verify your information before making any changes.',
  howcanIRetrieveMyPasswordQues: 'How can I retrieve my password?',
  howcanIRetrieveMyPasswordAns:
    'You can retrieve your password by clicking “forgot password?” Instructions on password retrieval will be sent to your email.',
  requiredFields: 'Required fields',
  getInTouchWithUs: 'Get in touch with us',
  enquiryType: 'Inquiry type',
  message: 'Message',
  firstName: 'First name',
  lastName: 'Last name',
  sending: 'Sending...',
  businessDetails: 'Business details',
  soldToNumber: 'Sold-to number',
  businessName: 'Business name',
  currentPassword: 'Current Password',
  verifyNewPassword: 'Verify New Password',
  enterYourCurrentPassword: 'Enter your current password',
  infoText: 'To update this information, kindly',
  loginToSeePrice: 'Login to see price',
  itemCode: 'Item code',
  genericName: 'Generic Name',
  category: 'Category',
  subCategory: 'Sub-category',
  imagesIllustrationPurposeOnly:
    'Images are for illustration purpose only, This item is sold by UOM',
  hoverToZoom: 'Hover to zoom',
  downloadPrivacyPolicy: 'Download privacy policy',
  findManufacturer: 'Find Manufacturer',
  vatIncluded: 'Vat included',
  shopByManufacturer: 'Shop by Manufacturers',
  paymentMethod: 'Payment method',
  reviewYourOrder: 'Review your order',
  review: 'Review',
  reviewOrderIfCorrectClickCompleteOrder:
    'Please review your order and if all is correct, click "Complete order"',
  subTotalLabel: 'Subtotal',
  signUpEstoreAccountDetails:
    'Sign up for an E-store account by completing the details below',
  areYouExistingCustomerOfGetz:
    'Are you an existing customer of Getz Healthcare Phillippines?*',
  areYouExistingCustomerOfGetzHK:
    'Are you an existing customer of Getz Healthcare Hong Kong?*',
  enterRegisteredBusinessName: 'Enter your registered Business Name',
  businessAddress: 'Business address',
  addressLineOne: 'Address Line 1',
  addressLineTwo: 'Address Line 2',
  province: 'Province',
  enterProvince: 'Enter province',
  barangay: 'Barangay',
  enterBarangay: 'Enter Barangay',
  zipCode: 'Zip code',
  enterZipCode: 'Enter zip code',
  enterYourBusinessContactNumber: 'Enter your business contact number',
  userAccountDetails: 'User account details',
  enterYourFirstName: 'Enter your first name',
  enterYourLastName: 'Enter your last name',
  enterYourCurrentRole: 'Enter your current role',
  enterYourEmailAddress: 'Enter your email address',
  mobileNumber: 'Mobile number',
  toBeUsedFor2FA: 'To be used for 2FA verification',
  submitting: 'Submitting',
  soldToNumberLabel: 'Sold to number',
  canFoundAtUpperLeftSideInvoice:
    'Can be found at upper left side of your invoice',
  goToHomePage: 'Go to HomePage',
  thankYouSigningUp: 'Thank you for signing up!',
  whatHappensNext: 'What happens next?',
  beforeYouCanLogin:
    'Before you can login, please allow us to verify your account details',
  onceOurVerification:
    'Once our verification is complete, we will email you the details on how to login to your account.',
  loginCredEmailedAfterVerificationComplete:
    'Your login credentials will be emailed to you after the verification is completed.',
  noBrandsFound: 'No brands found',
  noResultsFound: 'No results',
  noPromotionsFound: 'No Promotions Found',
  verifyPhoneNumber: 'Verify Phone Number',
  pleaseEnterVerificationCodeSent: 'Please enter the verification code sent to',
  enterTheVerificationCode: 'Enter the verification code',
  resendCode: 'Resend code',
  verificationCodeSent: 'Verification code sent successfully',
  thereIsNoAddressToPickup: 'Please select pick up address',
  partnerWithUsFillTheDetails: 'Partner with us..!! Fill the details',
  weWillGetBackToYouAsSoonAsWeCan: 'We will get back to you as soon as we can',
  pickup: 'Pick up',
  emailErrorMsg: 'Please enter a valid email address. Eg-abc@xyz.com',
  updateProductQuantity: 'Update product quantity',
  noProductItem: 'no items are available to reorder',
  productQuantity: 'Product quantity',
  collect: 'Collect',
  enterCouponCodeName: 'Enter country code or name',
  removeItemFromCart: 'Do you want to remove this item from cart? ',
  yesProceed: 'Yes, Proceed.',
  moveToSavedItem: 'Move to saved items list instead.',
  moveToWishlist: 'MOVE TO WISHLIST',
  customTitle: 'Additional Details',
  itemCount: 'Item Count',
  unitofMeasureQues: 'Unit of Measure -',
  minimumPickingUnitQues: 'Minimum Picking Unit -',
  sellingUnitofMeasureQues: 'Selling Unit of Measure -',
  unitofMeasureAns:
    'standard units of measurements used when accounting for stock, and expressing them in quantities, e.g., tube, box, pack, etc.',
  minimumPickingUnitAns:
    'the minimum fixed number of units that can be ordered.',
  sellingUnitofMeasureAns:
    'standard units in which we sell this product e.g., tube, box, pack, etc',
  selectVariant: 'Select Variant',
  sizeChart: 'Size Chart',
  selectSize: 'Select Size',
  CanISeeMyInvoices: 'Can I see my invoices?',
  CanISeeMyInvoicesAns:
    'Yes, invoices from 2021 to current are viewable in E-Store.',
  validNumber: 'Enter a valid Number',
  supportedFileFormat: 'Supported file formats: pdf/ jpg/ jpeg/ png/ webp',
  invalidFileFormat: 'Invalid file format',
  weWillBeRightBack: `We'll be right back!`,
  sorryForInconvenience:
    'Sorry for the inconvenience. Our website is currently undergoing scheduled maintenance.',
  ThankYouForUnderstanding:
    'Thank you for your understanding. Meanwhile,you can visit our website',
  ordersAccount: 'Orders',
  wishlistAccount: 'Wishlist',
  pastItemAccount: 'Past items',
  addressAccount: 'Addresses',
  walletAccount: 'Wallet',
  ChooseAdrresses: 'Choose address',
  proceedToDelivery: 'Proceed To Delivery ',
  proceedToPickup: 'Proceed To Pick up',
  payable: 'Payable',
  ContinueShopping: 'Continue shopping',
  noNotificationYet: 'No notifications yet!',
  whatAreYouLookingFor: 'What are you looking for...',
  followUsOn: 'Follow us on',
  moveToCart: 'Move to cart',
  overview: 'Overview',
  selectOtherVariants: 'Select other variants',
  coupons: 'Coupons',
  viewAllCoupons: 'View all coupons',
  Buynow: 'Buy now',
  placeorder: 'Place order',
  EnterNewPassword: 'Enter New Password',
  EnterOldPassword: 'Enter Old Password',
  ReenterNewPassword: 'Re-enter New Password',
  trackHere: 'Track here',
  postedOn: 'Posted On: ',
  continueReading: 'Continue Reading',
  prev: 'Prev',
  viewOrderDetails: 'View order details',
  cartWishlistTitle: 'Buy from wishlist',
  cartPastItemTitle: 'Buy again',
  RatingAndReviews: 'Ratings and Review',
  RateProducts: 'Rate Products',
  writeReview: 'Write Review',
  reviewTitle: 'Review Title',
  rememberMe: 'Remember me',
  addPhoto: 'Add photos',
  sureYouWantToCancelReview: 'Are you sure you want to cancel? ',
  yourReviewWillNotSave: 'Your review will not be saved.',
  reviewsubmittedsuccessfully: 'Review submitted successfully!',
  uCanUploadUptoFive: '(You can upload upto 5 photos or videos - jpeg, png)',
  selectCourierService: 'Select Courier Service',
  courierName: 'Courier Name',
  deliveryEstimate: 'Delivery Estimate',
  deliveryCharges: 'Delivery Charges',
  cheapest: 'Cheapest',
  quickest: 'Quickest',
  freeItems: 'Free Items',
  customerRatingsAndReviews: 'Customer Ratings & Reviews',
  reviewers: 'reviewers',
  reviewer: 'reviewer',
  noReviewsYet: 'No Reviews yet',
  rateYourOrder: 'rate your order',
  selectDeliveryService: 'Select Delivery Service',
  otherCourierService: 'Other courier service',
  loginviaphonenumber: 'Log in via phone number',
  emailIdMobileNumber: 'E-mail or Phone number',
  loginViaEmailId: 'Log in via E-mail id',
  phNumber: 'Ph number',
  yourAccountIsSuccessfullyCreated: 'Your account is successfully created',
  allCoupons: 'All Coupons',
  validTill: 'Valid Till',
  till: 'Till',
  applied: 'Applied',
  eMail: 'E-mail',
  noCouponAvailable: 'No coupon available',
  enterYourEmail: 'Enter your email id to place an order.',
  noProductsToShow: 'No Products to show',
  pleaseEnterYourEmailToResetPassword:
    'Please add your email to continue resetting the password*',
  otpSentTomobile: 'Enter the OTP sent to your registered phone number*',
  otpSentToEmail: 'Enter the OTP sent to your Email*',
  passwordSentToYouremail:
    'Email added successfully to your account. We have sent a new password to your email.',
  passwordSentSuccessfullyEmail:
    'Your password is sent to your registered Email',
  yourpasswordhasbeensent: 'Your password has been sent',
  verifyEmail: 'Verify Email',
  thisItemHasNoVariant: 'This item has no variant',
  tag: 'Tag',
  seeMore: 'See More',
  seeMoreProducts: 'See More Products',
  seeLessProducts: 'See Less Products',
  recommendedBlog: 'Recommended Blogs',
  noBlogAvailable: 'No Blog Available',
  freebieItems: 'Freebie Items',
  bloglist: 'blog list',
  recommendedBlogList: 'recommended blog list',
  recommendedBlogCollection: 'recommended blog collection',
  popularTags: 'popular tags',
  storeUnavailable: 'Sorry, this store is currently unavailable.',
  SetupYourStoreOnZopping: ' Setup your store on Zopping',
  NoDataForStatements: 'no statement data',
  ThankYouWeHaveRecievedYourOrder: 'Thank you! We have received your order.',
  paymentUnSuccessfulTryLater: 'Payment unsuccessful. Please try again later.',
  enterDistrict: 'Enter District',
  customerNumber: 'Customer Number',
  enterYourCustomerNumber: 'Enter your Customer Number',
  postalCode: 'Postal code',
  thankYouForSigningUpForAsEstore:
    'Thank you for signing up for as E-store account',
  kindlyCheckYourEmailForYourLoginCreds:
    'Kindly check your email for your login credentials!',
  checkoutAnouncementText:
    'We only deliver items within Hong Kong. For orders outside Hong Kong, please',
  addressLine1: 'Address Line 1',
  addressLine2: 'Address Line 2',
  addressLine3: 'Address Line 3',
  addressLine4: 'Address Line 4',
  country: 'Country',
  customernumber: 'Customer number',
  totalPrice: 'Total Price',
  contactUsForMoreInfo: 'Contact us for more information',
  creditExceeed: `Your Total Order value exceeds your available credit balance. Kindly
  contact us for more information.`,
  refundDetail: 'Refund Detail',
  refundDate: 'Refund Date:',
  transactionID: 'Transaction id',
  totalAmountRefunded: 'Total Amount Refunded',
  success: 'Success',
  reschedule: 'Reschedule',
  rescheduleOrder: 'Reschedule Order',
  preferredDateSlot: 'Preferred Date',
  preferredTimeslot: 'Preferred Timeslot',
  selectSlot: 'Select Slot',
  totalAmountPaid: 'Total Amount Paid',
  total: 'Total',
  deliverFee: 'Delivery Fee',
  viewInvoice: 'View Invoice',
  pickupFee: 'Pick up Fee',
  codDeliveryText: 'Please pay the dues at the time of delivery',
  pendingRefund: 'Pending Refund:',
  refundprocessMessage: 'Your refund will be processed in 24-48 hrs',
  returnOrder: 'Return Order',
  trackOrder: 'Track Order',
  orderDetail: 'Order Detail',
  priceLowToHigh: 'Price Low To High',
  priceHighToLow: 'Price High To Low',
  whatNew: "What's new",
  betterDiscount: 'Better Discount',
  writeYourReview: 'Write your review here',
  giveYourReviewTitle: 'Give your review title',
  selectTheReason: 'Select the reason',
  withYourMessage: 'Write your message ',
  returnType: 'Return type',
  photo: 'Photo',
  type: 'Type',
  PLACED: 'PLACED',
  PACKING: 'PACKING',
  PACKED: 'PACKED',
  CANCELLED: 'CANCELLED',
  COMPLETED: 'COMPLETED',
  RETURN: 'RETURN',
  DELIVERED: 'DELIVERED',
  DISPATCHED: 'DISPATCHED',
  WALLET: 'WALLET',
  ONLINE: 'ONLINE',
  PENDING: 'PENDING',
  couponCodeIsRequired: 'Coupon code is required',
  attachFile: 'Attach file',
  showingResultsFor: 'Showing results for',
  referralCodeIsExpired: 'Referral code is expired',
  referralCodeIsApplied: 'Referral code is applied',
  view: 'VIEW',
  freeGift: 'Free Gifts',
  itemName: 'Item Name',
  choose: 'Choose',
  RecaptchaisRequired: 'Recaptha is required',
  youHaveSelected: 'You have selected',
  Within: 'Within',
  Today: 'Today',
  Tomorrow: 'Tomorrow',
  seeLeftHandSideGetzInvoice:
    'See left hand side of your Getz Healthcare Invoice',
  yourOrder: 'Your Order',
  hasBeenDispatch: 'has been dispatched!',
  reviews: 'Reviews',
  bilingAddressAndShippingAddressText:
    'Billing address is same as the shipping address',
  billingAddress: 'Billing Address',
  billingAddressError: 'Billing Address is required',
  selectStore: 'Select Store',
  selectPickUpLocation: 'Select Pick up Location',
  myOrder: 'My Order',
  productFrom: 'Product From',
  referYours: 'Refer yours',
  friendEarnUpto: 'Friends & Earn Up To',
  whenTheySignupTheyGet: 'When they sign up, they get',
  intheirWallet: 'in their wallet',
  whenTheymaketheirFirstpurchaseYouGet:
    'When they make their first purchase, you get',
  inYourWallet: 'in your wallet',
  referYourFriendNow: 'Refer your friends now',
  copy: 'Copy',
  earnUpto: 'Earn Up To',
  emailOrPhoneNumberSignup: 'Email or Phone Number',
  createYourAccount: 'Create your account',
  whenTheyMakeTheirFirstPurchaseEarnUpto:
    'When they make their first purchase, Earn upto',
  referralCode: 'Referral Code',
  allTransationHostory: 'All Transaction History',
  enterAmount: 'Enter Amount',
  orderReturn: 'Order return',
  All: 'All',
  Credit: 'Credit',
  Debit: 'Debit',
  hideAddress: 'Hide addresses',
  emailOrPhone: 'Email or Mobile Number',
  soldBy: 'Sold By',
  taxIncluded: 'Tax included.',
  writeAReview: 'Write a review',
  customerReviews: 'CUSTOMER REVIEWS',
  pleaseLoginToSeeTheReviews: 'Please login to see the reviews',
  beTheFirstToReview: 'Be the first to review this product!',
  useADifferentAddress: 'Use a different address',
  sameAsShippingAddress: 'Same as shipping address',
  useADifferentBillingAddress: 'Use a different billing address',
  shippingMethod: 'ShippingMethod',
  incluOfAllTaxes: '(Incl. of all taxes)',
  couponOrGiftCard: 'Coupon or Gift Card',
  rewards: 'Rewards',
  offerDiscount: 'Offer Discount',
  onlinePaymentDiscount: 'Online Payment Discount',
  codPaymentDiscount: 'COD Payment Discount',
  price: 'Price',
  payOnPickup: 'Pay on Pick up',
  deliver: 'Deliver',
  buildYourOwn: 'Build your own bundle',
  grossAmount: 'Gross Amount',
  selectAll: 'Select all',
  totalSelectedQuantity: 'Total Selected Quantity:',
  viewcart: 'View Cart',
  signinandsignup: 'Sign In / Sign up',
  customerLogin: 'Customer Login',
  newCustomer: 'New Customer? Sign Up!',
  forgotpassword: 'Forgot Password',
  followUsOn: 'Follow us on',
  poweredByZopping: 'Powered by Zopping',
  backToMenu: 'Back to Menu',
  share: 'Share',
  deleteAccount: 'Delete Account',
  referAFriend: 'Refer a friend',
  inviteYourFriendsUsingReferralCode:
    'Invite your friends by sharing your referral code',
  enterReferralCode: 'Enter your referral code',
  otp: 'OTP',
  fullName: 'Full name',
  platformCharge: 'Platform Charge',
  handlingCharge: 'Handling Charge',
  eWallet: 'E-Wallet',
}

export default en
